// extracted by mini-css-extract-plugin
export var dropdownIcon = "_qz-6";
export var imgContainer = "_qz-3";
export var menuIcon = "_qz-5";
export var pillWrapper = "_qz-2";
export var pillsContainer = "_qz-1";
export var subscriptionCard = "_qz-0";
export var subscriptionLogo = "_qz-4";